import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Tab from '../../components/elements/Tab/Tab';
import Pangkalan from './Pangkalan';
import SubPangkalan from './SubPangkalan';
import styles from './styles.scoped.css';

export default function Faq() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab') || 'pangkalan';

  const tabList = [
    { label: 'Pangkalan', value: 'pangkalan' },
    { label: 'Subpangkalan', value: 'subpangkalan' },
  ];

  const handleChangeTab = (val) => {
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('tab', val);
    navigate('?' + newSearchParams.toString());
  };

  return (
    <div className={styles.root}>
      <Tab
        data={tabList}
        defaultValue={currentTab}
        onChange={handleChangeTab}
      />
      {currentTab === 'pangkalan' ? <Pangkalan /> : <SubPangkalan />}
    </div>
  );
}
